

/**
 *  
 * 
 * @returns {array} The configuration needed for AntDTable
 */
export function getColumns(actionColumn, eventColumn) {
    const rawColumns = [
  {
    title: 'Application Name',
    dataIndex: 'app_name',
    key: 'app_name'
  },
  {...eventColumn},
  {
    title: 'HTTP Method',
    dataIndex: 'operation',
    key: 'operation'
  },
  {
    title: 'Application URL',
    dataIndex: 'url',
    key: 'url'
  },
  {
    title: 'Creation Date',
    dataIndex: 'create_date',
    key: 'create_date'
  },
  {
    title: 'Last Update',
    dataIndex: 'update_date',
    key: 'update_date'
  },
  {...actionColumn}
]
    return rawColumns;
}
